import React, { useEffect, useState, useRef } from 'react';
import StatementModal from '../components/StatementModal';
import CustomAlert from '../components/CustomAlert';
import moment from 'moment';
import DocumentFileViewer from '../components/DocmentFileViewer';

import { Worker, Viewer } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import { pdfjs } from 'react-pdf';

// 正确配置Worker路径，版本号一致
pdfjs.GlobalWorkerOptions.workerSrc = `${window.location.origin}/pdf.worker.min.js`;


export default function ClientInfo({ org, files, partners, refreshOrder, onBack }) {
  const [showStatement, setShowStatement] = useState(false);
  const [pendingPartner, setPendingPartner] = useState(null);
  const [alert, setAlert] = useState({ open: false, message: '', type: 'info' });
  const [fileItem, setFileItem] = useState("");
  const [fileItemShow, setFileItemShow] = useState(false);
  const [fileType, setFileType] = useState('pdf');
  const pdfForPreview = useRef();


  console.log("partners", partners);
  const handleStartVerify = (partner) => {
    if (partner.face_status !== '认证通过') {
      // 还没人脸识别
      setPendingPartner(partner);
      setShowStatement(true);
    } else {
      //人脸识别通过了，需要判断是否在一秒钟之内，之内的话直接跳转签名页面
      if (!partner.face_verified_at) {
        setPendingPartner(partner);
        setShowStatement(true);
        return;
      }
      const diff = moment().diff(moment(partner.face_verified_at), 'seconds')
      if (diff <= 1) {
          window.location.href = `/sign-before?certifyId=${partner.certify_id}`;
      } else {
          // 超过1秒钟未签名，更新为认证失败
          fetch(`/api/face/expireCertify?certify_id=${partner.certify_id}`, { method: 'POST' }).catch(() => {});
          setPendingPartner(partner);
          setShowStatement(true);
      }
    }
  };

  const handleAgreeStatement = () => {
    setShowStatement(false);
    // 直接开始阿里云认证
    startAliyunVerify(pendingPartner);
    setPendingPartner(null);
  };

  // 直接调用阿里云认证
  const startAliyunVerify = async (partner) => {
    if (typeof window.getMetaInfo !== 'function') {
      setAlert({
        open: true,
        message: '请确认认证人的信息是否正确，有疑问请联系管理人员',
        type: 'error'
      });
      return;
    }

    const metaInfo = JSON.stringify(window.getMetaInfo());

    try {
      const res = await fetch(`/api/face/initAliyunVerify`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: partner.name,
          id_number: partner.id_number,
          partner_id: partner.id,
          metaInfo: metaInfo
        })
      });

      const data = await res.json();

      if (data.code === 0 && data.certifyUrl) {
        // 直接跳转，不显示提示
        window.location.href = data.certifyUrl;
      } else {
        setAlert({
          open: true,
          message: data.msg || '发起认证失败，请重试',
          type: 'error'
        });
      }
    } catch (err) {
      setAlert({
        open: true,
        message: '网络错误，请重试',
        type: 'error'
      });
    }
  };

  const handleCancelStatement = () => {
    setShowStatement(false);
    setPendingPartner(null);
  };


  // const sendUpdateStatus = async (id) => {
  //   const res = await fetch(`/api/client/updateStatus?id=${id}`, {
  //       method: 'GET',
  //       headers: { 'Content-Type': 'application/json' },
  //     });
  //     const data = await res.json();
  //     console.log('updateStatus',data);
  //   return '认证失败'
  // }

  return (
    <>
      <div style={{
        maxWidth: '600px',
        margin: '20px auto',
        padding: '0 16px',
        minHeight: '100vh'
      }}>
        <div style={{
          background: '#fff',
          borderRadius: '16px',
          padding: 'clamp(20px, 5vw, 32px)',
          boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
          border: '1px solid #e9ecef',
          width: '100%',
          maxWidth: '100%'
        }}>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            marginBottom: '24px'
          }}>
            <button
              onClick={onBack}
              style={{
                background: '#6c757d',
                color: '#fff',
                border: 'none',
                borderRadius: '8px',
                padding: '8px 16px',
                fontSize: '14px',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                marginRight: '16px'
              }}
              onMouseOver={(e) => {
                e.target.style.background = '#5a6268';
                e.target.style.transform = 'translateY(-1px)';
              }}
              onMouseOut={(e) => {
                e.target.style.background = '#6c757d';
                e.target.style.transform = 'translateY(0)';
              }}
            >
              ← 返回
            </button>
            <h2 style={{
              color: '#2c3e50',
              margin: '0',
              fontSize: '24px',
              fontWeight: '700'
            }}>
              订单信息
            </h2>
          </div>

          <div style={{
            background: '#f8f9fa',
            borderRadius: '12px',
            padding: '20px',
            marginBottom: '32px',
            border: '1px solid #e9ecef'
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              marginBottom: '16px'
            }}>
              <span style={{ fontSize: '20px', marginRight: '8px' }}>📋</span>
              <h3 style={{
                color: '#495057',
                margin: '0',
                fontSize: '18px',
                fontWeight: '600'
              }}>
                基本信息
              </h3>
            </div>

            {/* 业务流水号 - 单独显示在顶部 */}
            <div style={{
              background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
              border: '1px solid #dee2e6',
              borderRadius: '8px',
              padding: '12px 16px',
              marginBottom: '20px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between'
            }}>
              <span style={{
                color: '#6c757d',
                fontWeight: '500',
                fontSize: '14px'
              }}>
                业务流水号：
              </span>
              <span style={{
                color: '#495057',
                fontWeight: '600',
                fontSize: '16px',
                fontFamily: 'monospace'
              }}>
                {org.flow_no || '未填写'}
              </span>
            </div>

            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(2, 1fr)',
              gap: 'clamp(8px, 2vw, 12px)',
              fontSize: 'clamp(12px, 3vw, 14px)'
            }}>
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '4px'
              }}>
                <span style={{
                  color: '#6c757d',
                  fontWeight: '500',
                  fontSize: 'clamp(12px, 2.5vw, 14px)'
                }}>校验码：</span>
                <span style={{
                  color: '#495057',
                  fontWeight: '600',
                  fontSize: 'clamp(13px, 3vw, 14px)',
                  wordBreak: 'break-all'
                }}>{org.code || '未填写'}</span>
              </div>
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '4px'
              }}>
                <span style={{
                  color: '#6c757d',
                  fontWeight: '500',
                  fontSize: 'clamp(12px, 2.5vw, 14px)'
                }}>创建日期：</span>
                <span style={{
                  color: '#495057',
                  fontWeight: '600',
                  fontSize: 'clamp(13px, 3vw, 14px)',
                  wordBreak: 'break-all'
                }}>
                  {org.code_created_at ? new Date(org.code_created_at).toLocaleString('zh-CN', { timeZone: 'Asia/Shanghai' }) : '未记录'}
                </span>
              </div>
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '4px'
              }}>
                <span style={{
                  color: '#6c757d',
                  fontWeight: '500',
                  fontSize: 'clamp(12px, 2.5vw, 14px)'
                }}>机构名称：</span>
                <span style={{
                  color: '#495057',
                  fontWeight: '600',
                  fontSize: 'clamp(13px, 3vw, 14px)',
                  wordBreak: 'break-all'
                }}>{org.name || '未填写'}</span>
              </div>
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '4px'
              }}>
                <span style={{
                  color: '#6c757d',
                  fontWeight: '500',
                  fontSize: 'clamp(12px, 2.5vw, 14px)'
                }}>机构类型：</span>
                <span style={{
                  color: '#495057',
                  fontWeight: '600',
                  fontSize: 'clamp(13px, 3vw, 14px)',
                  wordBreak: 'break-all'
                }}>{org.type || '未填写'}</span>
              </div>
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '4px'
              }}>
                <span style={{
                  color: '#6c757d',
                  fontWeight: '500',
                  fontSize: 'clamp(12px, 2.5vw, 14px)'
                }}>统一社会信用代码：</span>
                <span style={{
                  color: '#495057',
                  fontWeight: '600',
                  fontSize: 'clamp(13px, 3vw, 14px)',
                  wordBreak: 'break-all'
                }}>{org.credit_code || '未填写'}</span>
              </div>
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '4px'
              }}>
                <span style={{
                  color: '#6c757d',
                  fontWeight: '500',
                  fontSize: 'clamp(12px, 2.5vw, 14px)'
                }}>法定代表人：</span>
                <span style={{
                  color: '#495057',
                  fontWeight: '600',
                  fontSize: 'clamp(13px, 3vw, 14px)',
                  wordBreak: 'break-all'
                }}>{org.legal_person || '未填写'}</span>
              </div>
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '4px'
              }}>
                <span style={{
                  color: '#6c757d',
                  fontWeight: '500',
                  fontSize: 'clamp(12px, 2.5vw, 14px)'
                }}>负责人持股比例：</span>
                <span style={{
                  color: '#495057',
                  fontWeight: '600',
                  fontSize: 'clamp(13px, 3vw, 14px)',
                  wordBreak: 'break-all'
                }}>{org.share_ratio ? `${org.share_ratio}%` : '未填写'}</span>
              </div>
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '4px'
              }}>
                <span style={{
                  color: '#6c757d',
                  fontWeight: '500',
                  fontSize: 'clamp(12px, 2.5vw, 14px)'
                }}>负责人电话：</span>
                <span style={{
                  color: '#495057',
                  fontWeight: '600',
                  fontSize: 'clamp(13px, 3vw, 14px)',
                  wordBreak: 'break-all'
                }}>{org.phone || '未填写'}</span>
              </div>
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '4px'
              }}>
                <span style={{
                  color: '#6c757d',
                  fontWeight: '500',
                  fontSize: 'clamp(12px, 2.5vw, 14px)'
                }}>机构通信地址：</span>
                <span style={{
                  color: '#495057',
                  fontWeight: '600',
                  fontSize: 'clamp(13px, 3vw, 14px)',
                  wordBreak: 'break-all'
                }}>{org.address || '未填写'}</span>
              </div>
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '4px'
              }}>
                <span style={{
                  color: '#6c757d',
                  fontWeight: '500',
                  fontSize: 'clamp(12px, 2.5vw, 14px)'
                }}>业务类型：</span>
                <span style={{
                  color: '#495057',
                  fontWeight: '600',
                  fontSize: 'clamp(13px, 3vw, 14px)',
                  wordBreak: 'break-all'
                }}>{org.business_type || '未填写'}</span>
              </div>
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '4px'
              }}>
                <span style={{
                  color: '#6c757d',
                  fontWeight: '500',
                  fontSize: 'clamp(12px, 2.5vw, 14px)'
                }}>印章名称：</span>
                <span style={{
                  color: '#495057',
                  fontWeight: '600',
                  fontSize: 'clamp(13px, 3vw, 14px)',
                  wordBreak: 'break-all'
                }}>{org.seal_names || '未填写'}</span>
              </div>
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '4px'
              }}>
                <span style={{
                  color: '#6c757d',
                  fontWeight: '500',
                  fontSize: 'clamp(12px, 2.5vw, 14px)'
                }}>应核验人数：</span>
                <span style={{
                  color: '#495057',
                  fontWeight: '600',
                  fontSize: 'clamp(13px, 3vw, 14px)',
                  wordBreak: 'break-all'
                }}>{org.should_verify_count ? `${org.should_verify_count}人` : '未设置'}</span>
              </div>
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '4px'
              }}>
                <span style={{
                  color: '#6c757d',
                  fontWeight: '500',
                  fontSize: 'clamp(12px, 2.5vw, 14px)'
                }}>参与核验人数：</span>
                <span style={{
                  color: '#495057',
                  fontWeight: '600',
                  fontSize: 'clamp(13px, 3vw, 14px)',
                  wordBreak: 'break-all'
                }}>{org.actual_verify_count ? `${org.actual_verify_count}人` : '0人'}</span>
              </div>
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '4px'
              }}>
                <span style={{
                  color: '#6c757d',
                  fontWeight: '500',
                  fontSize: 'clamp(12px, 2.5vw, 14px)'
                }}>是否登报：</span>
                <span style={{
                  color: '#495057',
                  fontWeight: '600',
                  fontSize: 'clamp(13px, 3vw, 14px)',
                  wordBreak: 'break-all'
                }}>
                  {org.is_announcement === 1 ? '是' : org.is_announcement === 0 ? '否' : '未填写'}
                </span>
              </div>
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '4px'
              }}>
                <span style={{
                  color: '#6c757d',
                  fontWeight: '500',
                  fontSize: 'clamp(12px, 2.5vw, 14px)'
                }}>见报日期：</span>
                <span style={{
                  color: '#495057',
                  fontWeight: '600',
                  fontSize: 'clamp(13px, 3vw, 14px)',
                  wordBreak: 'break-all'
                }}>
                  {org.announcement_date ? (() => {
                    const d = new Date(org.announcement_date);
                    if (isNaN(d)) return org.announcement_date;
                    const pad = n => n.toString().padStart(2, '0');
                    return `${d.getFullYear()}/${pad(d.getMonth()+1)}/${pad(d.getDate())}`;
                  })() : '未填写'}
                </span>
              </div>
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '4px'
              }}>
                <span style={{
                  color: '#6c757d',
                  fontWeight: '500',
                  fontSize: 'clamp(12px, 2.5vw, 14px)'
                }}>报刊名称：</span>
                <span style={{
                  color: '#495057',
                  fontWeight: '600',
                  fontSize: 'clamp(13px, 3vw, 14px)',
                  wordBreak: 'break-all'
                }}>{org.announcement_paper || '未填写'}</span>
              </div>
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '4px'
              }}>
                <span style={{
                  color: '#6c757d',
                  fontWeight: '500',
                  fontSize: 'clamp(12px, 2.5vw, 14px)'
                }}>是否有法人股东：</span>
                <span style={{
                  color: '#495057',
                  fontWeight: '600',
                  fontSize: 'clamp(13px, 3vw, 14px)',
                  wordBreak: 'break-all'
                }}>
                  {org.has_legal_partner === 1 ? '是' : org.has_legal_partner === 0 ? '否' : '未填写'}
                </span>
              </div>
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '4px'
              }}>
                <span style={{
                  color: '#6c757d',
                  fontWeight: '500',
                  fontSize: 'clamp(12px, 2.5vw, 14px)'
                }}>经办人：</span>
                <span style={{
                  color: '#495057',
                  fontWeight: '600',
                  fontSize: 'clamp(13px, 3vw, 14px)',
                  wordBreak: 'break-all'
                }}>{org.agent || '未填写'}</span>
              </div>
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '4px'
              }}>
                <span style={{
                  color: '#6c757d',
                  fontWeight: '500',
                  fontSize: 'clamp(12px, 2.5vw, 14px)'
                }}>经办人电话：</span>
                <span style={{
                  color: '#495057',
                  fontWeight: '600',
                  fontSize: 'clamp(13px, 3vw, 14px)',
                  wordBreak: 'break-all'
                }}>{org.agent_phone || '未填写'}</span>
              </div>
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '4px'
              }}>
                <span style={{
                  color: '#6c757d',
                  fontWeight: '500',
                  fontSize: 'clamp(12px, 2.5vw, 14px)'
                }}>短信接收人：</span>
                <span style={{
                  color: '#495057',
                  fontWeight: '600',
                  fontSize: 'clamp(13px, 3vw, 14px)',
                  wordBreak: 'break-all'
                }}>
                  {org.sms_receivers ? org.sms_receivers.split('\n').join(', ') : '未设置'}
                </span>
              </div>

              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '4px'
              }}>
                <span style={{
                  color: '#6c757d',
                  fontWeight: '500',
                  fontSize: 'clamp(12px, 2.5vw, 14px)'
                }}>已核验通过股权比例：</span>
                <span style={{
                  color: '#495057',
                  fontWeight: '600',
                  fontSize: 'clamp(13px, 3vw, 14px)',
                  wordBreak: 'break-all'
                }}>{org.verified_share_ratio || '0%'}</span>
              </div>
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '4px'
              }}>
                <span style={{
                  color: '#6c757d',
                  fontWeight: '500',
                  fontSize: 'clamp(12px, 2.5vw, 14px)'
                }}>已核验通过股东人数：</span>
                <span style={{
                  color: '#495057',
                  fontWeight: '600',
                  fontSize: 'clamp(13px, 3vw, 14px)',
                  wordBreak: 'break-all'
                }}>
                  {partners.filter(p => p.face_status === '认证通过').length}人
                </span>
              </div>
              <div style={{
                gridColumn: '1 / -1',
                display: 'flex',
                flexDirection: 'column',
                gap: '4px'
              }}>
                <span style={{
                  color: '#6c757d',
                  fontWeight: '500',
                  fontSize: 'clamp(12px, 2.5vw, 14px)'
                }}>备注信息：</span>
                <span style={{
                  color: '#495057',
                  fontWeight: '600',
                  fontSize: 'clamp(13px, 3vw, 14px)',
                  wordBreak: 'break-all'
                }}>{org.remark || '无'}</span>
              </div>
            </div>
          </div>

          {/* 订单状态和进度 */}
          <div style={{
            background: '#e7f3ff',
            borderRadius: '12px',
            padding: '20px',
            marginBottom: '32px',
            border: '1px solid #b3d9ff'
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              marginBottom: '16px'
            }}>
              <span style={{ fontSize: '20px', marginRight: '8px' }}>📊</span>
              <h3 style={{
                color: '#0056b3',
                margin: '0',
                fontSize: '18px',
                fontWeight: '600'
              }}>
                订单状态
              </h3>
            </div>
            <div style={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gap: '16px',
              fontSize: '14px'
            }}>
              <div>
                <span style={{ color: '#0056b3', fontWeight: '500' }}>订单状态：</span>
                <span style={{
                  color: org.status === '已结单' ? '#28a745' : '#ffc107',
                  fontWeight: '600',
                  padding: '2px 8px',
                  borderRadius: '12px',
                  background: org.status === '已结单' ? '#d4edda' : '#fff3cd',
                  fontSize: '12px'
                }}>
                  {org.status || '未结单'}
                </span>
              </div>

              <div>
                <span style={{ color: '#0056b3', fontWeight: '500' }}>修改时间：</span>
                <span style={{ color: '#495057', fontWeight: '600' }}>
                  {org.last_save_date ? new Date(org.last_save_date).toLocaleString('zh-CN', { timeZone: 'Asia/Shanghai' }) : '未记录'}
                </span>
              </div>

            </div>
          </div>

          <div style={{
            display: 'flex',
            alignItems: 'center',
            marginBottom: '20px'
          }}>
            <span style={{ fontSize: '20px', marginRight: '8px' }}>👥</span>
            <h3 style={{
              color: '#495057',
              margin: '0',
              fontSize: '18px',
              fontWeight: '600'
            }}>
              参与核验人员
            </h3>
          </div>
          <div style={{
            display: 'grid',
            gap: '12px'
          }}>
            {partners.map(p => (
              <div
                key={p.id}
                style={{
                  background: p.face_status === '认证通过' && p.signStatus === '签名成功' ? '#f8f9fa' : '#fff',
                  border: `2px solid ${p.face_status === '认证通过' && p.signStatus === '签名成功' ? '#dee2e6' : '#e9ecef'}`,
                  borderRadius: '12px',
                  padding: '16px',
                  transition: 'all 0.2s ease',
                  cursor: p.face_status !== '认证通过' || p.signStatus !== '签名成功' ? 'pointer' : 'default',
                  opacity: p.face_status === '认证通过' && p.signStatus === '签名成功' ? 0.7 : 1
                }}
                onMouseOver={(e) => {
                  if (p.face_status !== '认证通过' || p.signStatus !== '签名成功') {
                    e.currentTarget.style.borderColor = 'var(--primary-color)';
                    e.currentTarget.style.transform = 'translateY(-2px)';
                    e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
                  }
                }}
                onMouseOut={(e) => {
                  if (p.face_status !== '认证通过' || p.signStatus !== '签名成功') {
                    e.currentTarget.style.borderColor = '#e9ecef';
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = 'none';
                  }
                }}
                onClick={() => {
                  if (p.face_status !== '认证通过' || p.signStatus !== '签名成功') {
                    handleStartVerify(p);
                  }
                }}
              >
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  flexWrap: 'wrap',
                  gap: '12px'
                }}>
                  <div style={{
                    display: 'flex',
                    alignItems: 'center'
                  }}>
                    <div>
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                        marginBottom: '8px'
                      }}>
                        <div style={{
                          fontSize: '16px',
                          fontWeight: '600',
                          color: '#495057',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '8px'
                        }}>
                          {p.name}
                          {(p.is_legal_person == 1) && (
                            <span style={{
                              background: '#dc3545',
                              color: '#fff',
                              fontSize: '10px',
                              padding: '2px 6px',
                              borderRadius: '8px',
                              fontWeight: '500'
                            }}>
                              法人
                            </span>
                          )}
                        </div>
                        <div style={{
                          fontSize: '12px',
                          color: '#6c757d'
                        }}>
                          {p.id_number}
                        </div>
                      </div>

                      {/* 参与人员详细信息 */}
                      <div style={{
                        display: 'flex',
                        gap: '12px',
                        marginTop: '12px',
                        fontSize: '13px'
                      }}>
                        <div style={{
                          padding: '8px 12px',
                          background: '#f8f9fa',
                          borderRadius: '6px',
                          border: '1px solid #e9ecef',
                          flex: '1'
                        }}>
                          <span style={{ color: '#6c757d', fontWeight: '500' }}>出资比例：</span>
                          <span style={{ color: '#495057', fontWeight: '600' }}>
                            {p.share_ratio ? `${p.share_ratio}%` : '未填写'}
                          </span>
                        </div>

                        <div style={{
                          padding: '8px 12px',
                          background: '#f8f9fa',
                          borderRadius: '6px',
                          border: '1px solid #e9ecef',
                          flex: '1'
                        }}>
                          <span style={{ color: '#6c757d', fontWeight: '500' }}>是否法人：</span>
                          <span style={{ color: '#495057', fontWeight: '600' }}>
                            {p.is_legal_person == 1 ? '是' : '否'}
                          </span>
                        </div>
                      </div>

                      {/* 法人单位信息 */}
                      {(p.is_legal_person == 1) && (p.company_name || p.company_credit_code) && (
                        <div style={{
                          marginTop: '8px',
                          padding: '8px',
                          background: '#f8f9fa',
                          borderRadius: '6px',
                          border: '1px solid #e9ecef'
                        }}>
                          <div style={{
                            fontSize: '11px',
                            color: '#6c757d',
                            marginBottom: '4px',
                            fontWeight: '500'
                          }}>
                            🏢 法人单位信息
                          </div>
                          {p.company_name && (
                            <div style={{
                              fontSize: '11px',
                              color: '#495057',
                              marginBottom: '2px'
                            }}>
                              单位：{p.company_name}
                            </div>
                          )}
                          {p.company_credit_code && (
                            <div style={{
                              fontSize: '11px',
                              color: '#495057'
                            }}>
                              代码：{p.company_credit_code}
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                  <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minWidth: 'fit-content',
                    flex: '1',
                    marginLeft: 'auto',
                    gap: '8px'
                  }}>
                    {p.face_status === '认证通过' ? (
                      <>
                        <div style={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          gap: '4px'
                        }}>
                          <span style={{
                            padding: '4px 12px',
                            borderRadius: '20px',
                            fontSize: '12px',
                            fontWeight: '600',
                            background: p.signStatus === '签名成功' ? '#28a745' : '#dc3545',
                            color: '#fff',
                            border: p.signStatus === '签名成功' ? '1px solid #28a745' : '1px solid #dc3545'
                          }}>
                            {/* 这里修改一下,如果超过一秒钟则修改数据库信息 */}
                            {p.signStatus === '签名成功' ? '认证通过' : moment().diff(moment(p.face_verified_at), 'seconds') <= 0 ? '认证通过' : '认证失败' }
                          </span>
                          {p.face_verified_at && (
                            <span style={{
                              fontSize: '10px',
                              color: '#6c757d',
                              textAlign: 'center'
                            }}>
                              {(() => {
                                try {
                                  const date = new Date(p.face_verified_at);
                                  if (isNaN(date.getTime())) {
                                    console.log('Invalid date:', p.face_verified_at);
                                    return p.face_verified_at; // 直接显示原始值
                                  }
                                  return date.toLocaleString('zh-CN');
                                } catch (error) {
                                  console.log('Date parsing error:', error, p.face_verified_at);
                                  return p.face_verified_at; // 直接显示原始值
                                }
                              })()}
                            </span>
                          )}
                          {moment().diff(moment(p.face_verified_at), 'seconds') <= 1 || p.signStatus === '签名成功' ? <span style={{
                            padding: '4px 12px',
                            borderRadius: '20px',
                            fontSize: '12px',
                            fontWeight: '600',
                            background: '#28a745',
                            color: '#fff',
                            border: '1px solid #28a745',
                            cursor: 'pointer'
                          }}>
                            {p.signStatus === '签名成功' ? '签名成功' : moment().diff(moment(p.face_verified_at), 'seconds') <= 1 ? '待签名' : '同意办理'}
                          </span> : null}
                          {p.signTime && p.signStatus === '签名成功' ? (
                            <span style={{
                              fontSize: '10px',
                              color: '#6c757d',
                              textAlign: 'center'
                            }}>
                              {(() => {
                                try {
                                  const date = new Date(p.signTime);
                                  if (isNaN(date.getTime())) {
                                    console.log('Invalid date:', p.signTime);
                                    return p.signTime; // 直接显示原始值
                                  }
                                  return date.toLocaleString('zh-CN');
                                } catch (error) {
                                  console.log('Date parsing error:', error, p.signTime);
                                  return p.signTime; // 直接显示原始值
                                }
                              })()}
                            </span>
                          ) : null}
                        </div>
                      </>
                    ) : (
                      <span style={{
                        padding: '4px 12px',
                        borderRadius: '20px',
                        fontSize: '12px',
                        fontWeight: '600',
                        background: p.face_status === '认证失败' ? '#dc3545' : '#ffc107',
                        color: p.face_status === '认证失败' ? '#fff' : '#000',
                        border: `1px solid ${p.face_status === '认证失败' ? '#dc3545' : '#ffc107'}`
                      }}>
                        {p.face_status === '认证失败' ? '❌ 认证失败' : '⏳ 待认证'}
                      </span>
                    )}
                    {/* 签名和签章显示区域 */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                      {p.signUrl && (
                          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <span style={{ marginBottom: '4px', fontSize: '12px' }}>负责人签字</span>
                            <div
                                style={{
                                  position: 'relative',
                                  cursor: 'pointer'
                                }}
                                onClick={() => {
                                  window.open(p.signUrl);
                                }}
                            >
                              <img
                                  src={p.signUrl}
                                  alt="签名"
                                  style={{
                                    width: '60px',
                                    height: '30px',
                                    objectFit: 'contain',
                                    border: '1px dashed #ccc',
                                    borderRadius: '4px'
                                  }}
                              />
                            </div>
                          </div>
                      )}

                      {p.officialSealUrl && (
                          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                            <span style={{ marginBottom: '4px', fontSize: '12px' }}>单位盖章</span>
                            <div
                                style={{
                                  position: 'relative',
                                  cursor: 'pointer'
                                }}
                                onClick={() => {
                                  window.open(p.officialSealUrl);
                                }}
                            >
                              <img
                                  src={p.officialSealUrl}
                                  alt="签章"
                                  style={{
                                    width: '60px',
                                    height: '30px',
                                    objectFit: 'contain',
                                    border: '1px dashed #ccc',
                                    borderRadius: '4px'
                                  }}
                              />
                            </div>
                          </div>
                      )}
                    </div>
                    {/* 签名和签章显示区域 */}
                  </div>
                </div>
              </div>
            ))}
          </div>
          {files && files.length > 0 && org.is_sign_complete ? <h3 style={{
              color: '#2d8cf0',
              marginTop: 'clamp(20px, 5vw, 24px)',
              fontSize: 'clamp(16px, 4vw, 20px)'
            }}>已签章文件</h3> : null}
          {/*点击完成签名后，可以查看签名*/}
          {files && files.length > 0 && org.is_sign_complete ? <div style={{
            width: '100%',
            padding: '15px 15px',
            marginTop: '10px',
            backgroundColor: '#d4edda',
            border: '2px solid #c1e3c8',
            borderRadius: '10px'
          }}>
            
            {files && files.map((item, index) => (
              <div key={item.fileUrl} style={{
                width: '100%', padding: '5px 0',
                display: 'flex', flexDirection: 'row', alignItems: 'center'
              }}>
                <div style={{ flex: '1', fontSize: '12px', fontWeight: '500' }}>{index + 1}、{item.fileName}</div>
                <div style={{
                  padding: '3px 10px', fontSize: '11px',
                  color: '#fff', borderRadius: '3px', marginLeft: '10px'
                }}
                  onClick={() => {
                    // if (item.fileUrl) {
                    //   window.open(item.fileUrl);
                    // } else {
                    //   setAlert({ open: true, message: '数据错误' });
                    // }
                  }}>
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px' // 添加按钮间距
                  }}>
                    {/* 下载按钮（蓝色） */}
                    <div
                        style={{
                          padding: '3px 10px',
                          fontSize: '12px',
                          backgroundColor: '#019fe6',
                          color: '#fff',
                          borderRadius: '12px',
                          cursor: 'pointer',
                          transition: 'all 0.2s',
                          ':hover': {
                            backgroundColor: '#019fe6'
                          }
                        }}
                        onClick={() => {
                          if (item.fileUrl) {
                            // 创建隐藏的下载链接
                            const link = document.createElement('a');
                            link.href = item.fileUrl;
                            link.download = item.fileName || 'download';
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                          } else {
                            setAlert({ open: true, message: '数据错误' });
                          }
                        }}
                    >下载</div>
                    <div
                        style={{
                          padding: '3px 10px',
                          fontSize: '12px',
                          backgroundColor: '#019fe6',
                          color: '#fff',
                          borderRadius: '12px',
                          cursor: 'pointer',
                          transition: 'all 0.2s',
                          ':hover': {
                            backgroundColor: '#019fe6'
                          }
                        }}
                        onClick={() => {
                          const ext = item.fileUrl.split('.').pop().toLowerCase();
                          const isPdf = ['pdf'].includes(ext);
                          const isWord = ['doc', 'docx'].includes(ext);
                          // const fullUrl = item.fileUrl.startsWith('http') ? item.fileUrl : `${window.location.origin}${item.fileUrl}`;
                          setFileItemShow(true);
                          if (isPdf) {
                              setFileType("pdf");
                          } else if (isWord) {
                              setFileType(ext);
                          }
                          setFileItem(item.fileUrl)
                        }}
                    >查看</div>
                  </div>
                </div>
              </div>
            ))}
          </div> : null}

           {fileItemShow && (
            
                    <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: "rgba(0,0,0,0.6)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 1000,
                    }}
                    >
                       
                    <div
                        style={{
                        width: "95%",
                        height: "65%",
                        backgroundColor: "#fff",
                        borderRadius: "10px",
                        overflow: "auto",
                        padding: "10px",
                        display: "flex",
                        flexDirection: "column",
                        }}
                    >
                        {/* 关闭按钮 */}
                        <div style={{ padding: "10px", textAlign: "right" }}>
                            <text style={{
                            display: 'inline-block',
                            textAlign: 'left',
                            padding: '5px 5px',
                            fontSize: '20px',
                            color: '#888',
                            marginRight: '10vw'
                          }}>💡可放大屏幕阅读</text>
                         <button onClick={() => setFileItemShow(false)}>关闭</button>
                        </div>

                        {/* 文件预览 */}
                        {/* 文件预览 */}
                        <div className="flex-1 overflow-hidden" id='pdfForPreview' ref={pdfForPreview} style={{ flex: 1, borderTop: "1px solid #ccc", height: '100%', width: '100%' }}>
                            { fileType != 'pdf' ? 
                                ( <DocumentFileViewer 
                                    fileUrl={`https://rlrz.cqyz.com.cn/${fileItem}`}
                                    fileType={fileType}
                                    />
                                )
                                : 
                                (
                                    <Worker workerUrl={`${window.location.origin}/pdf.worker.min.js`}>
                                        <Viewer fileUrl={`https://rlrz.cqyz.com.cn/${fileItem}`} />
                                    </Worker>
                                )
                            }
                        </div>
                    </div>
                </div>
                )}

          {/*已签章文件结束*/}
         
          <div style={{
            marginTop: '24px',
            padding: '16px',
            background: '#e7f3ff',
            borderRadius: '8px',
            border: '1px solid #b3d9ff',
            textAlign: 'center'
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: '8px'
            }}>
              <span style={{ fontSize: '16px', marginRight: '8px' }}>💡</span>
              <span style={{ fontSize: '14px', fontWeight: '600', color: '#0056b3' }}>
                操作提示
              </span>
            </div>
            <p style={{
              margin: '0',
              fontSize: '13px',
              color: '#0056b3',
              lineHeight: '1.5'
            }}>
              {(() => {
                const pendingPartners = partners.filter(p => p.face_status !== '认证通过');
                if (pendingPartners.length > 0) {
                  return '请找到您本人的姓名，然后点击方框内的【待认证】或者【认证失败】标记，去完成实人认证和电子签章。';
                } else {
                  return '如您的姓名处显示【认证通过】和【签名成功】请等待审核结果，否则您应先去完成实人认证和电子签章。';
                }
              })()}
            </p>
          </div>
        </div>
      </div>

      <StatementModal
        open={showStatement}
        onAgree={handleAgreeStatement}
        onCancel={handleCancelStatement}
        partnerName={pendingPartner?.name || ''}
        partnerIdNumber={pendingPartner?.id_number || ''}
        orgName={org?.name || ''}
        businessType={org?.business_type || ''}
      />

      <CustomAlert
        open={alert.open}
        message={alert.message}
        type={alert.type}
        onClose={() => setAlert({ ...alert, open: false })}
      />
    </>
  );
}
